import { LMS_CHAPTER_NAME } from "../../../../utils/cookiesmanager";
import Modal from "../../../modal/Modal";
import Button from "../ButtonComponent";

import CheckSvgComponent from "../CheckSvgComponent";
import { BUTTON_VARIANTS } from "../constant";

import styles from "./styles.module.scss";

const ChapterCompleteSuccessfulComponent = (props) => {
  const { chapterNumber , show , handleRedirection } = props;

  const chapterName = localStorage.getItem(LMS_CHAPTER_NAME);

  return (
    <>
      <Modal visible={show}>
        <div className={styles["assessment-wrapper"]}>
            <CheckSvgComponent />
          <div className={styles.title}>Successfully Completed</div>
          <div className={styles.description}>
            You have completed {chapterName}
            <span  className={styles.chapter}>{ chapterNumber}</span>.
          </div>
          <div className={styles["button-wrapper"]}>
            <Button
            label="Continue"
            buttonVariant={BUTTON_VARIANTS.PRIMARY}
            className={styles["button-class"]}
            onClick={handleRedirection}
        />
          </div>
        </div>
      </Modal>
    </>
  );
};

export default ChapterCompleteSuccessfulComponent;
